// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__2ep5W","box":"styles_box__2Z1Fl"};